import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {getHasListSendingMessagesInSentFolder} from '../../../../store/featureFlags/featureFlagsSelectors';
import {MessageUndoBannerState} from '../../../../store/panels/app/banners/bannersState';
import {undoMessageBannerAsyncAction} from '../../../../store/panels/app/banners/undoBannersActions';
import {AppPanelId} from '../../../../store/panels/panelStateBase';
import {getIsGuidedDemoActive} from '../../../../store/stateless/guidedDemoSelectors';
import {MessageUndoBanner} from './messageUndoBanner';

/*
 * Props.
 */

interface MessageUndoBannerContainerProps {
  panelId: AppPanelId;
  state: MessageUndoBannerState;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  isGuidedDemoActive: getIsGuidedDemoActive,
  hasListSendingMessagesInSentFolder: getHasListSendingMessagesInSentFolder,
}));

export const MessageUndoBannerContainer = connect(
  mapStateToProps,
  {undoMessageBannerAsync: undoMessageBannerAsyncAction},
  (stateProps, dispatchProps, ownProps: MessageUndoBannerContainerProps) => ({
    ...stateProps,
    ...ownProps,
    onUndoClick: () => {
      const {panelId, state} = ownProps;
      dispatchProps.undoMessageBannerAsync(panelId, state);
    },
  }),
)(MessageUndoBanner);
